import SettingsLayout from 'modules/profile/components/settings-layout'
import { settingsMenuLocoKeys } from 'modules/profile/constants/settings-menu-loco-keys'
import UserPlanSkeleton from 'modules/profile/user-plan/components/user-plan-skeleton'
import UserPlanTable from 'modules/profile/user-plan/components/user-plan-table'
import { UserPlanLoco } from 'modules/profile/user-plan/constants/user-plan-loco'
import { useUserPlan } from 'modules/profile/user-plan/hooks/use-user-plan'
import { useUserSettings } from 'modules/profile/user-settings/hooks/use-user-settings'
import { NextPage } from 'next'
import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props'

const UserPlan: NextPage = () => {
  const { t } = useLocoTranslation()
  const { userPlanData } = useUserPlan()
  const { userSettings } = useUserSettings()

  return (
    <SettingsLayout
      needSave={false}
      titles={[{ caption: t(settingsMenuLocoKeys.my_plan), isStatic: true }]}
    >
      {userPlanData && userSettings ? (
        <UserPlanTable
          currentUserPlanData={userPlanData}
          showWithTax={!userSettings.user?.taxNumber}
        />
      ) : (
        <UserPlanSkeleton />
      )}
    </SettingsLayout>
  )
}

export const getServerSideProps = getBaseServerSideProps(UserPlanLoco, 'global.settings')

export default UserPlan
